import { render, staticRenderFns } from "./ProtocolHierarchyStats.vue?vue&type=template&id=84368112&scoped=true&"
import script from "./ProtocolHierarchyStats.vue?vue&type=script&lang=js&"
export * from "./ProtocolHierarchyStats.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolHierarchyStats.vue?vue&type=style&index=0&id=84368112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84368112",
  null
  
)

export default component.exports